import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { id: "inicio", label: "Inicio" },
  { id: "pagos", label: "Pagos" },
  { id: "automatizacion", label: "Automatización" },
  { id: "experiencia", label: "Experiencia" },
  { id: "conservatorio", label: "Conservatorio" },
  { id: "activos", label: "RWA" },
  { id: "multifirma", label: "Multifirma" },
  { id: "seguridad", label: "Seguridad" },
];

export const Navbar = ({ active, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const dark = true;

  const go = (id) => {
    onNavigate(id);
    setOpen(false);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
      className="fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-4"
    >
      <nav
        data-testid="navbar"
        className={`flex w-full max-w-6xl items-center justify-between rounded-full border px-5 py-3 backdrop-blur-2xl md:px-7 ${
          dark
            ? "border-white/15 bg-white/[0.06] shadow-[0_8px_40px_rgba(0,0,0,0.4)]"
            : "border-black/20 bg-canvas/80 shadow-[0_8px_32px_rgba(0,0,0,0.05)]"
        }`}
      >
        <button
          onClick={() => go("inicio")}
          data-testid="nav-logo"
          className={`flex items-center gap-2.5 ${dark ? "text-white" : "text-ink"}`}
        >
          <img
            src="/mockups/logo_mono.png"
            alt="Monograma Aurexis"
            className="h-[38px] w-auto select-none"
            draggable={false}
          />
          <span className="font-display text-2xl font-semibold tracking-tight">
            Aurexis
          </span>
        </button>

        <div className="hidden items-center gap-5 xl:flex">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              aria-current={active === l.id ? "page" : undefined}
              className={`relative font-accent text-sm transition-colors duration-300 ${
                active === l.id
                  ? dark
                    ? "text-white"
                    : "text-ink"
                  : dark
                    ? "text-white/55 hover:text-white"
                    : "text-ink-soft hover:text-ink"
              }`}
            >
              {l.label}
              {active === l.id && (
                <motion.span
                  layoutId="nav-underline"
                  className={`absolute -bottom-1.5 left-0 right-0 mx-auto h-1 w-1 rounded-full ${
                    dark ? "bg-white" : "bg-gold"
                  }`}
                />
              )}
            </button>
          ))}
        </div>

        <button
          onClick={() => go("acceso")}
          data-testid="nav-cta"
          className={`hidden rounded-full px-6 py-2.5 font-accent text-sm transition-colors duration-300 xl:inline-block ${
            active === "acceso"
              ? "bg-gold-light text-white"
              : "bg-gold text-white hover:bg-gold-light"
          }`}
        >
          Solicitar acceso
        </button>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className={`font-accent text-sm xl:hidden ${dark ? "text-white" : "text-ink"}`}
        >
          {open ? "Cerrar" : "Menú"}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute left-4 right-4 top-[6.5rem] z-50 rounded-3xl border border-white/12 bg-white/[0.06] p-6 shadow-[0_24px_70px_-24px_rgba(0,0,0,0.85)] backdrop-blur-2xl xl:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-4">
              {links.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  className={`text-left font-display text-2xl ${
                    active === l.id ? "text-white" : "text-white/80"
                  }`}
                >
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => go("acceso")}
                className="mt-2 rounded-full bg-gold px-6 py-3 text-center font-accent text-sm text-white"
              >
                Solicitar acceso
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
